import React, { useState } from 'react';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import axios from 'axios';
import PropTypes from 'prop-types';
import BuilderResults from '../BuilderResults';
import {
  API_KEY_ACCOUNTS,
  API_KEY_JOBS,
  SEARCH_API,
  API_URL_JOBS,
  COLORS,
} from '../../constants';

const UserSearch = props => {
  const [searchResults, setSearchResults] = useState(null);
  const [loading, setLoading] = useState(false);
  const { setBuilder, dispatchApiCallFailed, dispatchApiCallSuccess } = props;

  const style = {
    heading: {
      textAlign: 'center',
      fontSize: '2rem',
      margin: '2rem',
    },
    inputDiv: {
      marginRight: 'auto',
      marginLeft: 'auto',
      borderRadius: '5px',
      backgroundColor: COLORS.GREY,
    },
    inputForm: {
      width: '80%',
      marginLeft: 'auto',
      marginRight: 'auto',
      paddingTop: '2rem',
      paddingBottom: '2rem',
    },
    button: {
      fontSize: '1.1rem',
      marginTop: '1rem',
      color: COLORS.WHITE,
      backgroundColor: COLORS.GREEN,
    },
    buttonInv: {
      fontSize: '1.1rem',
      marginTop: '1rem',
      color: COLORS.GREEN,
      backgroundColor: COLORS.WHITE,
    },
    loading: {
      textAlign: 'center',
      marginRight: 'auto',
      marginLeft: 'auto',
    },
    BuilderResults: {
      width: '100%',
      margin: '2rem auto',
    },
    loadingWrapper: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: 200,
    },
  };

  const handleSubmit = async e => {
    try {
      e.preventDefault();
      const searchQuery = e.target[0].value;
      setLoading(true);
      const results = await searchApi(searchQuery);
      const resultsWithPriority = await appendPriorityAndStatus(results);
      setSearchResults(resultsWithPriority);
      setLoading(false);
      dispatchApiCallSuccess();
    } catch {
      dispatchApiCallFailed();
    }
  };

  const searchApi = async searchQuery => {
    const token = localStorage.getItem('accessToken');
    try {
      const emailSearchResponse = await axios({
        method: 'get',
        headers: {
          'Content-Type': 'application/json',
          'x-api-key': `${API_KEY_ACCOUNTS}`,
          Authorization: `Bearer ${token}`,
        },
        url: `${SEARCH_API}?email=${encodeURIComponent(searchQuery)}`,
        validateStatus(status) {
          return status === 200; // default
        },
      });
      const nameSearchResponse = await axios({
        method: 'get',
        headers: {
          'Content-Type': 'application/json',
          'x-api-key': `${API_KEY_ACCOUNTS}`,
          Authorization: `Bearer ${token}`,
        },
        url: `${SEARCH_API}?name=${searchQuery}`,
        validateStatus(status) {
          return status === 200; // default
        },
      });
      const response = {};
      emailSearchResponse.data.results.forEach(user => {
        // console.log('User', user);
        response[user.username] = user;
      });
      nameSearchResponse.data.results.forEach(user => {
        response[user.username] = user;
      });
      return Object.values(response);
    } catch (err) {
      throw err;
    }
  };

  const appendPriorityAndStatus = builders => {
    const promises = builders.map(async builder => {
      try {
        const updatedBuider = await builderApi(builder);
        return updatedBuider;
      } catch {
        return builder;
      }
    });
    return Promise.all(promises);
  };

  const builderApi = async builder => {
    try {
      const token = localStorage.getItem('accessToken');
      const response = await axios({
        method: 'get',
        headers: {
          'Content-Type': 'application/json',
          'x-api-key': `${API_KEY_JOBS}`,
          Authorization: `Bearer ${token}`,
        },
        url: `${API_URL_JOBS}/admin/businesses/${builder.username}/priority`,
        validateStatus(status) {
          return status === 200 || status === 404;
        },
      });

      builder.email =
        response.status === 200 && response.data
          ? response.data.email
          : builder.email;

      if (response.status === 200 && response.data) {
        if (response.data.approved === 0) {
          builder.approved = 'Not Active';
        }
        if (response.data.approved === 1) {
          builder.approved = 'Active';
        }
        if (response.data.approved === 2) {
          builder.approved = 'Deactivated';
        }
      }

      builder.priorityListing =
        response.status === 200 && response.data
          ? response.data.priority_listing
          : 0;

      builder.deactivate =
        response.status === 200 && response.data
          ? response.data.status === 2
          : false;
      builder.reason =
        builder.deactivate && response.status === 200 && response.data
          ? response.data.reason
          : '';
      // console.log('builder', builder);
      return builder;
    } catch (err) {
      // console.log('builderErr', builder);
      return builder;
    }
  };

  return (
    <>
      {/* <div style={style.heading}>
        <ToggleButtonGroup onChange={handleSectionChange} exclusive>
          <ToggleButton
            fullWidth
            value="search"
            style={currentSection === 'search' ? style.button : style.buttonInv}
          >
            Search Users
          </ToggleButton>
          <ToggleButton
            value="approval"
            style={
              currentSection === 'approval' ? style.button : style.buttonInv
            }
          >
            Awaiting Approval
          </ToggleButton>
        </ToggleButtonGroup>
      </div> */}
      <div style={style.inputDiv}>
        <form onSubmit={handleSubmit} style={style.inputForm}>
          <TextField
            id="standard-full-width"
            label="Search user by email or name"
            fullWidth
            margin="normal"
            variant="outlined"
          />
          <Button variant="contained" type="submit" style={style.button}>
            Search
          </Button>
        </form>
      </div>
      {loading && (
        <div style={style.loadingWrapper}>
          <CircularProgress size={40} />
        </div>
      )}
      {searchResults && (
        <div style={style.BuilderResults}>
          <BuilderResults builders={searchResults} setBuilder={setBuilder} />
        </div>
      )}
    </>
  );
};

const propTypes = {
  setBuilder: PropTypes.func,
  dispatchApiCallFailed: PropTypes.func,
  dispatchApiCallSuccess: PropTypes.func,
};

UserSearch.propTypes = propTypes;

export default UserSearch;
